import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';
import { API_URL } from '../../config'
import $ from 'jquery'
class Product extends Component {

    constructor() {
        super();
        this.state = {

            emailID: "",
            pwd: "",
            loginIP: "",
            loginBrowser: "",
            deviceType: "",
            userLocation: "",
            logIsp: "",
            ii: 0,
            actions: [],
            pLogo: "",
            opcarr: [],
            count: 1,
            poddet:[
                // {
                //     "prodCode": "P001",
                //     "prodName": "Product_1",
                //     "prodtype": "Type1",
                //     "onhand": "140",
                //     "uom": "Kg",
                    
                // },
                // {
                //     "prodCode": "P002",
                //     "prodName": "Product_2",
                //     "prodtype": "Type1",
                //     "onhand": "1490",
                //     "uom": "Kg",
                    
                // },
                // {
                //     "prodCode": "P003",
                //     "prodName": "Product_3",
                //     "prodtype": "Type2",
                //     "onhand": "166",
                //     "uom": "Kg",
                    
                // },
                // {
                //     "prodCode": "P004",
                //     "prodName": "Product_4",
                //     "prodtype": "Type3",
                //     "onhand": "1460",
                //     "uom": "Kg",
                    
                // },
                // {
                //     "prodCode": "P005",
                //     "prodName": "Product_5",
                //     "prodtype": "Type5",
                //     "onhand": "14",
                //     "uom": "Kg",
                    
                // },
                // {
                //     "prodCode": "P006",
                //     "prodName": "Product_6",
                //     "prodtype": "Type1",
                //     "onhand": "1400",
                //     "uom": "Kg",
                    
                // },
                // {
                //     "prodCode": "P007",
                //     "prodName": "Product_7",
                //     "prodtype": "Type4",
                //     "onhand": "190",
                //     "uom": "Kg",
                    
                // },
                // {
                //     "prodCode": "P008",
                //     "prodName": "Product_8",
                //     "prodtype": "Type5",
                //     "onhand": "14.96",
                //     "uom": "Kg",
                    
                // },
            ]
        }




    }
     componentDidMount(){  console.clear() 

        this.getpro()
        this.getdata()
    }
    getdata(val) {
        
    
        let data1 = {
            "itemCode":val
        }
        let logourl = API_URL + "/getItemByCode" ;
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem('token')
            },
            body: JSON.stringify(data1)
    
        };
        fetch(logourl, requestOptions)
            .then(res => res.json())
            .then(json => {
                console.log(json)
                   this.setState({poddet:json})
                // swal({
                //     title: "Done!",
                //     text: "Added Successfully",
                //     icon: "success",
                // });
                // document.getElementById("close123").click()
                // this. componentDidMount()
    
            })
            .catch((e) => {
                swal({
                    title: "OOPS!",
                    text: "Something went wong",
                    icon: "warning",
                });
    
                console.log(e)
            })
    }

    getpro() {
        // let pwd = document.getElementById("login-password").value
        // let email = document.getElementById("login-email").value
        
        // if (email == '' || pwd == '') {
        //     swal({
        //         title: "OOPS!",
        //         text: "Please enter your email and password!",
        //         icon: "warning",
        //     });

        //     return;
        // }
        //////////////////////////////
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','authorization': localStorage.getItem('token') },
            // body: JSON.stringify({
            //    // "email": email,
            //    // "password": pwd,
            //     "username":email,
            //      "password":pwd
            // })
        };

// $(".loading").removeClass("d-none")
// alert()
        let logourl = API_URL + "/allItems";
        fetch(logourl, requestOptions)
            .then(res => res.json())
            .then(json => {
                $(".loading").addClass("d-none")

                
                this.setState({poddet:json})
                //console.log("s",json=="")
                //   this. componentDidMount()

                //   this. componentDidMount()
            })
            .catch( (e) => {

                $(".loading").addClass("d-none")

                // swal({
                //     title: "OOPS!",
                //     text: "Please enter correct email and password!",
                //     icon: "warning",
                // });
    
                console.log(e)
            })
        //////////////////////////////

        // localStorage.setItem("email", email);
        // // let data={
        // //     "Email": email,
        // //     "Password": pwd
        // // }
        // let namearr = JSON.parse(localStorage.getItem("PATIENT"))
        // var passed = namearr.filter(function (element, index, array) {
        //     return (element.email == email && element.pass == pwd);
        // });
        // //console.log(name1,name1.email,name1.phone)
        // if (passed.length > 0) {
        //     localStorage.setItem("type", "PATIENT");
        //     window.location.href = "/dashboard";
        // }

        // namearr = JSON.parse(localStorage.getItem("BACKOFFICE"))
        // passed = namearr.filter(function (element, index, array) {
        //     return (element.email == email && element.pass == pwd);
        // });
        // //console.log(name1,name1.email,name1.phone)


        // namearr = JSON.parse(localStorage.getItem("POINTOFSALES"))
        // passed = namearr.filter(function (element, index, array) {
        //     return (element.email == email && element.pass == pwd);
        // });
        // //console.log(name1,name1.email,name1.phone)
        // if (passed.length > 0) {
        //     localStorage.setItem("type", "POINTOFSALES");
        //     window.location.href = "/dashboard2";
        // }

        // namearr = JSON.parse(localStorage.getItem("OPTICIAN"))
        // passed = namearr.filter(function (element, index, array) {
        //     return (element.email == email && element.pass == pwd);
        // });
        // //console.log(name1,name1.email,name1.phone)
        // if (passed.length > 0) {
        //     localStorage.setItem("type", "OPTICIAN");
        //     window.location.href = "/dashboard";
        // }




        // const requestOptions = {
        // const requestOptions = {
        // const requestOptions = {
        //     method: 'POST',
        //    headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },
        //     body: JSON.stringify({data})
        // };
        // let logourl ="http://localhost:5000/api/token";
        // fetch(logourl, requestOptions)
        //     .then(res => {  
        //         console.log(res.body);
        //          localStorage.setItem('data',res)
        //   //  window.location.href = "/dashboard2";


        //     })npm 

    }
   
  
    render() {


        return (
            <>




            

                <div class="content-overlay"></div>
                <div class="header-navbar-shadow"></div>
                <div class="content-wrapper">
                    <div class="content-header row">
                    </div>
                    <div class="content-body ">
                        <section id="basic-datatable">
                            <div class="row">
                                <div class="col">
                                    <div class="card px-2 pb-4">
                                        <div class="card-header border-bottom mr-1">
                                            <div class="head-label">
                                                <h4 class="mb-0">Product Master</h4>
                                            </div><div class="dt-action-buttons text-right">
                                                <div class="dt-buttons d-inline-flex">
                                                    {/*<div class="btn-group mr-1">
                                                        <button type="button" class="btn btn-outline-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        {window.$language.Export}
                                                        </button>
                                                        <div class="dropdown-menu ">
                                                        <a class="dropdown-item" href="javascript:void(0);"><i class="fas fa-print mr-50"></i>{window.$language.Print}</a>
                                                            <a class="dropdown-item" href="javascript:void(0);"><i class="fas fa-file-csv mr-50"></i>{window.$language.CSV}</a>
                                                            <a class="dropdown-item" href="javascript:void(0);"><i class="fas fa-file-excel mr-50"></i>{window.$language.Excel}</a>
                                                            <a class="dropdown-item" href="javascript:void(0);"><i class="fas fa-file-pdf mr-50"></i>{window.$language.PDF}</a>
                                                        </div>
        </div>*/}
            </div></div></div>

                                        <hr class="my-0" />
                                        <div class="d-flex justify-content-between align-items-center mx-0 row"><div class="col-sm-12 col-md-6">
                                            {/* {<div class="dataTables_length" id="DataTables_Table_0_length"><label>Show 
                                            <select name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" class="custom-select form-control"><option value="7">7</option>
                                        <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="75">75</option><option value="100">100</option></select></label>
                                        </div>} */}
                                        </div><div class="col-sm-12 col-md-4"><div id="DataTables_Table_0_filter" class="dataTables_filter pt-1"><label class="w-100"><input type="search" onChange={(data)=>this.getdata(data.target.value)} class="form-control rounded-lg shadow-sm" placeholder="Enter search text" aria-controls="DataTables_Table_0" /></label></div></div></div>
                                        <div class="table-responsive">
                                        <table class="datatables-basic table mt-1 shadow table-hover table table-striped">

                                            <thead class="thead-primary">
                                                <tr>
                                                    <th>Product Code  </th>
                                                    <th>Product Name </th>
                                                    <th>Parent Code Description </th>
                                                    <th>Product Family </th>
                                                    <th>Product Class </th>
                                                    <th>Status</th>
                                                    
                                                    

 

                                                </tr>
                                            </thead>
                                            <tbody  table-hover-animation >
                                            {this.state.poddet.map(det => (  
                                                    <tr>
                                                        
                                                        <td>{det.itemCode}</td>
                                                        <td>{det.itemName}</td>
                                                        <td>{det.parentCodeDescription}</td>
                                                        <td>{det.productFamily}</td>
                                                        <td>{det.productClass}</td>
                                                        
                                                        <td><span class="badge badge-pill badge-light-primary mr-1 status-badge">Active</span></td>
                               
                                                        
                                                     

                                                    </tr>))}
                                                
                                            </tbody>
                                        </table>
                                        </div>
                                        <nav aria-label="Page navigation example">
                                        <ul class="pagination mt-3 justify-content-center">
                                        <li class="page-item prev-item"><a class="page-link" href="javascript:void(0);"></a></li>
                                            <li class="page-item active"><a class="page-link" href="javascript:void(0);">1</a></li>
                                            <li class="page-item"><a class="page-link" href="javascript:void(0);">2</a></li>
                                            <li class="page-item"><a class="page-link" href="javascript:void(0);">3</a></li>
                                            <li class="page-item next-item"><a class="page-link" href="javascript:void(0);"></a></li>
                                        </ul>
                                            </nav>
                                    </div>
                                </div>
                            </div>
                     </section>
                    </div>
                </div>

</>

        );


    }
}
export default Product